/* Icon styles */
.easilGrayXDark {
  color: #2c2c2c;
}
